<dx-select-box
  [items]="this.expirationDescriptors"
  [(value)]="this.selectedExpiration"
  [disabled]="this.disabled"
  [showClearButton]="this.showClearButton"
  (onValueChanged)="this.onValueChanged($event)"
  [readOnly]="this.readOnly"
  [inputAttr]="this.inputAttr"
  [placeholder]="this.placeholder"
  fieldTemplate="field"
  itemTemplate="item"
>
  <div *dxTemplate="let data of 'field'">
    <dx-text-box [readOnly]="true" [value]="this.getText()"></dx-text-box>
  </div>

  <div *dxTemplate="let data of 'item'">
    <span [style.color]="this.getExpirationColor(data)">
       {{ data?.dateWithDaysToExpiration }}
    </span>
  </div>
</dx-select-box>